import { Formik } from "formik";
import React, { useState } from "react";
import { createCoachPasswordSchema } from "../../utils/schema";
import Eye from "../../components/form/Eye";
import ErrorMessage from "../../components/form/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { createCoachPassword } from "../../redux/features/coach/actions/authAction";
import Loader from "../../components/loader";
import { useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";

const CoachChangePasswordVerify = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isLoading } = useSelector((state) => state.coach.auth);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    let location = window?.location?.search?.split("=")[1] || "";

    const initialValues = {
        password: "",
        confirm_password: "",
    };

    const handleLogin = (values) => {
        const callback = (response) => {
            if (response?.success) {
                navigate(coachPaths?.CoachChangePasswordSuccess);
            } else {
                navigate(coachPaths?.CoachChangePasswordFailed);
            };
        };
        dispatch(createCoachPassword({
            id: location, payload: {
                password: values?.password
            }, callback
        }));
    };

    if (isLoading) {
        return <Loader />;
    };
    return (
        <>
            <div
                className="d-flex align-items-center justify-content-center"
                style={{ minHeight: "100vh", backgroundColor: "#c0c0c0f8" }}
            >
                <div className="card p-4 shadow" style={{ width: 500 }}>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={createCoachPasswordSchema}
                        onSubmit={(values, actions) => {
                            handleLogin(values);
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <img
                                    src="../assets/img/Nuvio_logo.png"
                                    alt="logo"
                                    className="d-block mx-auto mb-3"
                                    style={{ maxWidth: 150 }}
                                />
                                <h2 className="text-center mb-4">Create Password</h2>
                                <div className="mb-3 position-relative">
                                    <label className="form-label">New Password</label>
                                    <div className="position-relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            className="form-control pe-5"
                                            id="password"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values?.password}
                                        />
                                        <span
                                            className="position-absolute top-50 end-0 translate-middle-y"
                                            style={{ cursor: "pointer" }}
                                        >
                                            <Eye
                                                isEye={showPassword}
                                                onClick={() => setShowPassword(!showPassword)}
                                            />
                                        </span>
                                    </div>
                                    <ErrorMessage
                                        errors={errors}
                                        touched={touched}
                                        fieldName="password"
                                    />
                                </div>
                                <div className="mb-3 position-relative">
                                    <label className="form-label">Confirm Password</label>
                                    <div className="position-relative">


                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            className="form-control pe-5"
                                            value={values.confirm_password}
                                            id="confirm_password"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                        />
                                        <span
                                            className="position-absolute top-50 end-0 translate-middle-y me-0"
                                            style={{ cursor: "pointer" }}
                                        >
                                            <Eye
                                                isEye={showConfirmPassword}
                                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            />
                                        </span>
                                    </div>
                                    <ErrorMessage
                                        errors={errors}
                                        touched={touched}
                                        fieldName="confirm_password"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    className="ct_yellow_btn w-100 mt-3"
                                >
                                    Continue
                                </button>
                            </form>
                        )}
                    </Formik>
                </div>
            </div>
            <footer className="bg-dark text-white text-center py-3 mt-0">
                © Copyright <strong>Nuvio Team</strong>. All Rights Reserved
            </footer>
        </>
    )
};

export default CoachChangePasswordVerify;